
import React from 'react';
import { Box, Heading, Stack, RangeSlider, RangeSliderTrack, RangeSliderFilledTrack, RangeSliderThumb, Text, Link } from '@chakra-ui/react';
import { Link as RouterLink, useParams } from 'react-router-dom';

const categories = [
  { name: "Rings", path: "/products/rings" },
  { name: "Bracelets", path: "/products/bracelets" },
  { name: "Chains", path: "/products/chains" },
  { name: "Pendants", path: "/products/pendants" }
];

const Sidebar = ({ priceRange, setPriceRange }) => {
  const { category } = useParams();
  return (
    <Box p={4} bg="white" borderRadius="md" boxShadow="sm">
      <Box mb={8}>
        <Heading 
          as="h3" 
          fontSize="xl" 
          mb={4} 
          borderBottomWidth="1px" 
          pb={2}
          fontFamily="'Cormorant', serif"
          fontWeight="700"
          letterSpacing="0.5px"
        >
          Shop By
        </Heading>
        
        <Stack spacing={6}>
          {/* Categories Section */}
          <Box>
            <Heading 
              as="h4" 
              fontSize="lg" 
              mb={4}
              fontFamily="'Cormorant', serif"
              fontWeight="600"
            >
              Categories
            </Heading>
            <Stack spacing={1}>
              {categories.map((cat) => (
                <Link
                  key={cat.path}
                  as={RouterLink}
                  to={cat.path}
                  p={2}
                  borderRadius="md"
                  fontSize="md"
                  color={category === cat.name.toLowerCase() ? "black" : "gray.600"}
                  fontWeight={category === cat.name.toLowerCase() ? "bold" : "medium"}
                  bg={category === cat.name.toLowerCase() ? "gray.100" : "transparent"}
                  fontFamily="'Zain', sans-serif"
                  _hover={{ 
                    color: "black", 
                    textDecoration: "none",
                    bg: "gray.50"
                  }}
                  transition="all 0.2s"
                >
                  {cat.name}
                </Link>
              ))}
            </Stack>
          </Box>

          {/* Price Filter Section */}
          <Box>
            <Heading 
              as="h4" 
              fontSize="md" 
              mb={3}
              fontFamily="'Cormorant', serif"
              fontWeight="600"
            >
              Price
            </Heading>
            <Box px={2}>
              <RangeSlider 
                value={priceRange} 
                onChange={setPriceRange} 
                min={0} 
                max={2000} 
                step={50}
              >
                <RangeSliderTrack bg="gray.200">
                  <RangeSliderFilledTrack bg="black" />
                </RangeSliderTrack>
                <RangeSliderThumb 
                  index={0} 
                  boxSize={5}
                  bg="black"
                  border="2px solid white"
                  _focus={{ boxShadow: "0 0 0 3px rgba(0,0,0,0.2)" }}
                />
                <RangeSliderThumb 
                  index={1} 
                  boxSize={5}
                  bg="black"
                  border="2px solid white"
                  _focus={{ boxShadow: "0 0 0 3px rgba(0,0,0,0.2)" }}
                />
              </RangeSlider>
            </Box>
            <Text 
              mt={3} 
              fontSize="sm" 
              color="gray.700"
              fontWeight="600"
              fontFamily="'Zain', sans-serif"
            >
              ₹{priceRange[0]} - ₹{priceRange[1]}
            </Text>
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default Sidebar;
